import { useEffect, useRef } from 'react';

import { classNames } from '@/utils';
import useIntersectionObserver from '@/utils/hooks/utils/useIntersectionObserver';

import Loader from '@/components/base/Loader';

type LoadMoreInfiniteProps = {
    loadMore?: () => void;
    isLoadingMore?: boolean;
    className?: string;
};

const LoadMoreInfinite = ({ loadMore, isLoadingMore, className }: LoadMoreInfiniteProps) => {
    const loadMoreButtonRef = useRef<HTMLDivElement>(null);
    const loadMoreInViewPort = useIntersectionObserver(loadMoreButtonRef, { rootMargin: '0px' });

    useEffect(() => {
        if (!isLoadingMore && loadMoreInViewPort) {
            loadMore?.();
        }
    }, [isLoadingMore, loadMoreInViewPort]);

    return (
        <div
            ref={loadMoreButtonRef}
            className={classNames(
                'flex w-full justify-center pb-3 text-center text-icoGray-400',
                className
            )}>
            <Loader className="ml-3 h-4 w-4 text-icoGray-400 dark:text-icoDarkMode-wolf" />
        </div>
    );
};

export default LoadMoreInfinite;
